import utility from './utility'

const accountTransactions = {
    init: function() {
        const transactionsButton = document.querySelector("#account--transactions-load");
        if (transactionsButton) {
            transactionsButton.onclick = () => {
                this.loadTransactions();
            };
        }
    },

    loadTransactions: function() {
        const count = document.querySelectorAll("#account--transactions-list .history-row").length;
        const ajaxOptions = {
            url: "/api/web/account/get-transactions",
            method: "POST",
            data: "count=" + count,
            success: function(e) {
                var container = document.querySelector("#account--transactions-list");
                container.insertAdjacentHTML("beforeend", e.target.responseText);
                var lastItem = document.querySelector("#account--transactions-list .history-row:last-child");
                if (lastItem) {
                    if (lastItem.dataset.more == "0") {
                        var button = document.querySelector("#account--transactions-load");
                        button.parentNode.removeChild(button);
                    }
                }
            },
            always: function(e) {
                utility.enableButton(document.querySelector("#account--transactions-load"));
            }
        };
        utility.disableButton(document.querySelector("#account--transactions-load"));
        utility.ajaxRequest(ajaxOptions);
    }
}

export default accountTransactions


// WEBPACK FOOTER //
// ./assets/src/js/classes/accountTransactions.js